import Tooltip from '@/components/atoms/Tooltip';

import styles from './GroupTrack.module.scss';

interface PenNameTriggerProps {
    /** The pen and the bar's status, e.g. "03 · No Bioscope". */
    label: string;
}

/**
 * Covers a bar whose pen tag was hidden to avoid an overlap. A button, so keyboard and touch
 * users reach the pen name as a pointer does, and named by it for screen readers. Pressing it
 * does nothing more: focus opens the tooltip, as on the feeding dashboard's KPI notes.
 */
export default function PenNameTrigger(props: PenNameTriggerProps) {
    const { label } = props;

    return (
        <Tooltip content={label} layout="fill" targetClassName={styles.penTriggerTarget}>
            <button type="button" className={styles.penTrigger} aria-label={label} />
        </Tooltip>
    );
}
